import { render, staticRenderFns } from "./WayItem1.vue?vue&type=template&id=2c25c942&"
import script from "./WayItem1.vue?vue&type=script&lang=js&"
export * from "./WayItem1.vue?vue&type=script&lang=js&"
import style0 from "./WayItem1.vue?vue&type=style&index=0&id=2c25c942&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports